<template>

  <li
    class="list-group-item">
    <div class="d-flex">
        <div class="flex-grow-1">
          <img
            :src="urlImg"
            class="mb-2"
            style="max-width: 100px">
            <p>{{ description }}</p>
            <div
              v-if="integration.active === false"
              class="alert alert-warning">
              {{ integration.error_message }}
            </div>
        </div>
        <div :class="{'box-loading': loading}">
          <button
              type="button"
              class="btn btn-block"
              :class="hasIndegration ? 'btn-primary' : 'btn-outline-secondary'"
              @click="showModel">
              {{ $t('Setup') }}
              </button>
          <button
              v-if="hasIndegration"
              type="button"
              class="btn btn-block btn-outline-secondary"
              @click="remove">
              {{ $t('Remove') }}
              </button>
        </div>
    </div>

    <IntegrationForm
      v-if="show"
      :title="title"
      :keyName="keyName"
      :initIntegration="integration"
      @hideModal="hideModal"
      @saved="saved"
      @deleted="remove" />

  </li>

</template>

<script>
import IntegrationForm from './IntegrationForm'

export default {
  name: 'IntegrationItem',
  components: {
    IntegrationForm
  },
  props: {
    keyName: {
      type: String
    },
    urlImg: {
      type: String
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    integration: {
      type: [Object, null]
    }
  },
  data () {
    return {
      loading: false,
      show: false,
      validateErrors: {},
      errorMessage: null
    }
  },
  computed: {
    hasIndegration () {
      return this.integration && this.integration._id
    }
  },
  created () {
  },
  methods: {
    showModel () {
      this.show = true
    },
    hideModal () {
      this.show = false
    },
    saved () {
      this.hideModal()
      this.$emit('saved')
    },
    remove () {
      this.hideModal()

      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteIntegration', this.keyName)
        .then(result => {
          this.loading = false
          this.$emit('removed')
          this.hideModal()
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/IntegrationItem.vue